/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Main_MenuInputs */

const bn_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রধান মেনু`)
};

const de_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauptmenü`)
};

const el_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κύριο μενού`)
};

const en_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main menu`)
};

const es_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menú principal`)
};

const fr_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu principal`)
};

const hi_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुख्य मेन्यू`)
};

const hu_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Főmenü`)
};

const id_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu utama`)
};

const it_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menù principale`)
};

const ja_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メインメニュー`)
};

const ko_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메인 메뉴`)
};

const nl_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoofdmenu`)
};

const pl_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu główne`)
};

const pt_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu principal`)
};

const ru_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Главное меню`)
};

const sv_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huvudmeny`)
};

const tr_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ana menü`)
};

const uk_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Головне меню`)
};

const vi_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thực đơn chính`)
};

const zh_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主菜单`)
};

const zh_hant_action_main_menu = /** @type {(inputs: Action_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主選單`)
};

/**
* | output |
* | --- |
* | "Main menu" |
*
* @param {Action_Main_MenuInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const action_main_menu = /** @type {((inputs?: Action_Main_MenuInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Main_MenuInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_action_main_menu(inputs)
	if (locale === "de") return de_action_main_menu(inputs)
	if (locale === "el") return el_action_main_menu(inputs)
	if (locale === "en") return en_action_main_menu(inputs)
	if (locale === "es") return es_action_main_menu(inputs)
	if (locale === "fr") return fr_action_main_menu(inputs)
	if (locale === "hi") return hi_action_main_menu(inputs)
	if (locale === "hu") return hu_action_main_menu(inputs)
	if (locale === "id") return id_action_main_menu(inputs)
	if (locale === "it") return it_action_main_menu(inputs)
	if (locale === "ja") return ja_action_main_menu(inputs)
	if (locale === "ko") return ko_action_main_menu(inputs)
	if (locale === "nl") return nl_action_main_menu(inputs)
	if (locale === "pl") return pl_action_main_menu(inputs)
	if (locale === "pt") return pt_action_main_menu(inputs)
	if (locale === "ru") return ru_action_main_menu(inputs)
	if (locale === "sv") return sv_action_main_menu(inputs)
	if (locale === "tr") return tr_action_main_menu(inputs)
	if (locale === "uk") return uk_action_main_menu(inputs)
	if (locale === "vi") return vi_action_main_menu(inputs)
	if (locale === "zh") return zh_action_main_menu(inputs)
	return zh_hant_action_main_menu(inputs)
});